import type { Options } from '@segment/analytics-next';

import type { ContextOverride } from './types/store';

// Converts a per-event context override into Segment call `Options` (the web equivalent of the
// mobile enrichment closure). The override lands in the event's `context`, but ContextEnrichmentPlugin
// now always overwrites matching fields with the shared context, so overrides only stick for fields
// the shared context doesn't set. Returns `undefined` when no override is passed, so the enrichment
// is skipped for that call.
export const CustomContextMapper = {
  toOptions(contextOverride?: ContextOverride): Options | undefined {
    if (!contextOverride || Object.keys(contextOverride).length === 0) {
      return undefined;
    }
    return { context: contextOverride };
  },
};
